import React from 'react'
import {motion} from 'framer-motion'
import {imgWidth, topHeight} from '../Home/Hero/HeroBody'
import airForceShowImg from '../../assets/images/hero-img.jpg'
import Title from '../PageTitles/Title'
import aboutImg1 from '../../assets/images/about-img-1.jpg'
import './about.css'

const transition = {duration: 1, ease: [0.6, 0.01, -0.05, 0.9]}

function About() {
  return (
    <motion.div initial='initial' animate='animate' exit='exit'>
        <motion.div initial={{width: imgWidth, margin:"0 auto", y: `${topHeight}px`}}
        animate={{y:"0", width: "100%", transition: {delay:0.2, ...transition}}} className="img-container no-border main-lg">
            <img className='transition-width' src={airForceShowImg} alt="" />
        </motion.div>
        <div className="no-border m-4">
            <Title title='Established in' id='about-title' />
            <Title title=' 2001' id='about-title-2' />
        </div>
        <div className="container about-container">
            <div className="text-description">
                <p className='first-header'>Crossing hardwood comfort with off-court flair, the b-ball original gets you ready for all.</p>
                <p className='second-header'>
                    Premium materials like slub canvas underlays bring a classic look, while textured leather adds sophistication
                    to any outfit.
                    Vintage Sail accents on the outsole and Swoosh pair with throwback labeling for a retro boost. 
                </p>
            </div>
            <div className="img-container">
                <img className='transition-width' src={aboutImg1} alt="" />
            </div>
            <div className="text-description">
                <p className='second-header'>
                    <span className='serif'>Crossing hardwood comfort</span>
                    Premium materials like slub canvas underlays bring a classic look, while textured leather adds sophistication
                    to any outfit.
                    Vintage Sail accents on the outsole and Swoosh pair with throwback labeling for a retro boost. 
                </p>
                <p className='second-header'>
                    <span className='serif'>with off-court flair</span>
                    Premium materials like slub canvas underlays bring a classic look, while textured leather adds sophistication
                    to any outfit.
                    Vintage Sail accents on the outsole and Swoosh pair with throwback labeling for a retro boost. 
                </p>
            </div>
        </div>
        <div className="no-border m-4">
            <Title title='WE’VE GOT' id='about-title-3' />
            <Title title='ALL YOUR shoe' id='about-title-4' />
            <Title title='NEEDS COVERED' id='about-title-5' />
        </div>
        <div className="container">
            <div className="text-description">
                <p className='second-header'>
                    <span className='serif muted'>come and visit us at our local store for more!</span>
                </p>
            </div>
        </div>
    </motion.div>
  )
}

export default About